import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 0px 10px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 2fr;
  gap: 10px;
  justify-content: center;
  justify-items: center;
  align-items: flex-end;
  margin: 0px 15px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 7px;
`
